<template>
  <div class="reflexologie">
    <app-header :background-name="'see_wallpaper.jpg'">
      <h1>Stéphanie Lefebvre</h1>
      <h2>Réflexologie Plantaire Thaï</h2>
    </app-header>

    <div class="content">
      <article>
        <img src="~@/assets/background/refle-left.png" alt="flower" class="left">
        <div class="bloc">
          <h1>Réflexologie Plantaire Thaï...</h1>
          <p>
            La <span>réflexologie plantaire Thaï</span> est le fruit d’un savoir faire ancestral dont les origines remontent à plus
            de 5000 ans, en passant par le Tibet, l’Inde, la Chine, le Japon et la Thaïlande.
          </p>

          <p>
            <span>Douce et naturelle</span>, la réflexologie plantaire Thaï est une technique d’<span>harmonisation énergétique</span> qui associe
            des manœuvres enveloppantes à des pressions et des glissés, sur les zones réflexes des orteils jusqu’aux
            genoux.
          </p>

          <p>
            Cette méthode de soin naturel active les <span>capacités d’auto-guérison du corps</span> et renforce le système immunitaire. La relaxation induite par la
            réflexologie plantaire Thaï permet d’agir sur le bien-être, la qualité du sommeil, et suivant chacun,
            <span>favorise la détente musculaire, la digestion, le transit intestinal, la circulation sanguine, l’élimination des
              toxines et des douleurs</span>. Elle revitalise tout l’organisme grâce à des mouvements lents, rapides, fluides et précis
            et s’adresse à toute personne qui désire retrouver une paix, un calme intérieur.
          </p>
        </div>
        <img src="~@/assets/background/refle-right.png" alt="flower" class="right">
        <div class="bloc">
          <p>
            La réflexologie plantaire thaï <span>réharmonise les déséquilibres présents dans l’organisme</span>, et déverrouille les
            mécanismes de blocage de l’énergie vitale pouvant être à l’origine de troubles de la santé.
          </p>

          <p>
            Une séance de réflexologie plantaire débute par un <span>temps de parole, dans l’écoute et le respect</span>. Puis, le
            receveur, habillé, est installé confortablement sur la table de massage. Il est demandé de porter une tenue
            souple, dont un pantalon pouvant se relever aisément jusqu’au-dessus du genou, et de ne porter ni ceinture,
            ni bijou, ceci afin de ne pas entraver la libre circulation de l’énergie. Bien entendu, les pieds du receveur
            doivent être propres.
          </p>

          <p>
            La réflexologie plantaire ne peut que participer à un <span>processus d’auto-guérison</span> en action conjointe avec le
            travail effectué par votre médecin traitant.
          </p>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
  import AppHeader from '@/components/Header'

  export default {
    name: 'Reflexologie',
    components: { AppHeader }
  }
</script>

<style lang="scss" scoped>
  .reflexologie {
    display: flex;
    flex-direction: column;
    flex: 1;

    .content {
      position: relative;
      text-align: center;
      background-color: #f1fae7;
      align-items: center;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      @media screen and (max-width: 680px) {
        overflow: auto;
      }
      article {
        @include custom-article();
        img {
          position: absolute;
          z-index: 0;
          opacity: .5;

          &.left {
            bottom: -2vw;
            left: -1vw;
          }

          &.right {
            top: -1vw;
            right: -1vw;
          }
        }
      }
    }
  }

</style>
